// extracted by mini-css-extract-plugin
export default {"root":"TooltipUl_root__skhvJ"};